import { ReactNode, useEffect } from 'react';

import { FormGroup } from '../models/FormGroup';

import './Form.light.scss';
import './Form.dark.scss';

interface Props {
  children: ReactNode | ReactNode[];
  className?: string;
  formGroup?: FormGroup<Record<string, any>>;
  onSubmit?: () => void;
}

export function Form({ children, className, formGroup, onSubmit }: Props) {
  useEffect(() => {
    if (formGroup && onSubmit) {
      const onEnterKeyPressed = (event: KeyboardEvent) => {
        if (event.key === 'Enter' && formGroup.isValid()) {
          onSubmit();
        }
      };

      window.addEventListener('keyup', onEnterKeyPressed, false);
      return () => {
        window.removeEventListener('keyup', onEnterKeyPressed, false);
      };
    }
    return undefined;
  }, [formGroup, onSubmit]);

  return (
    <form
      className={'form' + (className ? ' ' + className : '')}
      onSubmit={event => event.preventDefault()}>
      {children}
    </form>
  );
}
